import authReducer from './authReducer';
import bookingReducer from './bookingReducer';
import customerReducer from './customerReducer';
import companyReducer from './companyReducer';
import driverReducer from './driverReducer';
import providerReducer from './providerReducer';
import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';
import eventsReducer from './eventsReducer';

const rootReducer = combineReducers({
    auth: authReducer, 
    booking: bookingReducer, 
    customer: customerReducer, 
    company: companyReducer,
    driver: driverReducer, 
    provider: providerReducer, 
    events: eventsReducer,
    firebase: firebaseReducer, 
    firestore: firestoreReducer
});

export default rootReducer;